import { render, staticRenderFns } from "./yujianfenzhenList.vue?vue&type=template&id=41b478c8&scoped=true&"
import script from "./yujianfenzhenList.vue?vue&type=script&lang=js&"
export * from "./yujianfenzhenList.vue?vue&type=script&lang=js&"
import style0 from "./yujianfenzhenList.vue?vue&type=style&index=0&id=41b478c8&rel=stylesheet%2Fless&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41b478c8",
  null
  
)

export default component.exports